export default __webpack_public_path__ + "images/pensatus-edit-profile-stones.svg";